class KvVideoViewer extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div class="kv-video-viewer__backdrop" data-kv-close></div>
      <div class="kv-video-viewer__stage">
        <div class="kv-video-viewer__topbar">
          <div class="kv-video-viewer__title" data-kv-title></div>
          <div class="kv-video-viewer__controls">
            <button type="button" class="kv-video-viewer__mute" data-kv-viewer-mute aria-label="Mute">
              <svg class="kv-video-viewer__icon-unmuted" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
              <svg class="kv-video-viewer__icon-muted" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="display:none;"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
            </button>
            <button type="button" class="kv-video-viewer__close" data-kv-close aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
            </button>
          </div>
        </div>
        <div class="kv-video-viewer__media" data-kv-media></div>
        <div class="kv-video-viewer__pause-overlay" data-kv-pause-overlay style="display:none;">
          <button type="button" class="kv-video-viewer__overlay-btn" data-kv-viewer-overlay-mute aria-label="Mute or unmute">
            <svg class="kv-video-viewer__icon-unmuted" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
            <svg class="kv-video-viewer__icon-muted" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="display:none;"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
          </button>
          <button type="button" class="kv-video-viewer__overlay-btn kv-video-viewer__overlay-play" data-kv-viewer-play aria-label="Play">
            <svg width="22" height="26" viewBox="0 0 8 10" fill="white"><polygon points="0,0 8,5 0,10"></polygon></svg>
          </button>
        </div>
        <button type="button" class="kv-video-viewer__nav kv-video-viewer__nav--up" data-kv-prev aria-label="Previous video">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
        </button>
        <button type="button" class="kv-video-viewer__nav kv-video-viewer__nav--down" data-kv-next aria-label="Next video">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="kv-video-viewer__tag" data-kv-tag></div>
      </div>
    `;

    this.querySelectorAll('[data-kv-close]').forEach((el) => el.addEventListener('click', () => this.close()));
    this.querySelector('[data-kv-prev]').addEventListener('click', () => this.go(-1));
    this.querySelector('[data-kv-next]').addEventListener('click', () => this.go(1));
    this.querySelector('[data-kv-viewer-mute]').addEventListener('click', () => this.toggleMute());
    this.querySelector('[data-kv-viewer-overlay-mute]').addEventListener('click', (e) => { e.stopPropagation(); this.toggleMute(); });
    this.querySelector('[data-kv-viewer-play]').addEventListener('click', (e) => { e.stopPropagation(); this.togglePlayPause(); });

    const media = this.querySelector('[data-kv-media]');
    const mediaHeight = () => media.getBoundingClientRect().height || 1;

    let startX = 0, startY = 0, startTime = 0, dragging = false, dragDirection = 0, previewSlide = null, tapCandidate = false;
    let rafId = null, pendingDelta = null;

    const beginDrag = (direction) => {
      if (!this.cards || !this.cards.length) return;
      dragDirection = direction;
      dragging = true;
      const nextIndex = (this.currentIndex + direction + this.cards.length) % this.cards.length;
      const card = this.cards[nextIndex];
      const clone = this.getCloneForCard(card, { silent: true });
      if (!clone) { dragging = false; return; }
      const sourceVideo = card.querySelector('[data-kv-video]');
      const posterUrl = sourceVideo ? sourceVideo.getAttribute('poster') : '';
      if (posterUrl) clone.setAttribute('poster', posterUrl);
      const bg = document.createElement('div');
      bg.className = 'kv-video-viewer__media-bg';
      if (posterUrl) bg.style.backgroundImage = 'url(' + posterUrl + ')';
      previewSlide = document.createElement('div');
      previewSlide.className = 'kv-video-viewer__slide';
      previewSlide.style.transform = 'translateY(' + (direction > 0 ? '100%' : '-100%') + ')';
      previewSlide.dataset.index = nextIndex;
      previewSlide.appendChild(bg);
      previewSlide.appendChild(clone);
      this.addLoadingScrim(previewSlide, clone);
      media.appendChild(previewSlide);
      clone.play().catch(() => {});
    };

    const updateDrag = (deltaY) => {
      if (!previewSlide) return;
      if (this.activeSlide) this.activeSlide.style.transform = 'translateY(' + deltaY + 'px)';
      const base = dragDirection > 0 ? '100%' : '-100%';
      previewSlide.style.transform = 'translateY(calc(' + base + ' + ' + deltaY + 'px))';
    };

    const commitDrag = () => {
      const nextIndex = parseInt(previewSlide.dataset.index, 10);
      const oldSlide = this.activeSlide;
      const clone = previewSlide.querySelector('video');
      const slide = previewSlide;

      slide.style.transition = 'transform .22s ease';
      if (oldSlide) oldSlide.style.transition = 'transform .22s ease';
      slide.style.transform = 'translateY(0)';
      if (oldSlide) oldSlide.style.transform = 'translateY(' + (dragDirection > 0 ? '-100%' : '100%') + ')';

      slide.addEventListener('transitionend', () => {
        if (oldSlide) {
          const oldVideo = oldSlide.querySelector('video');
          if (oldVideo) oldVideo.pause();
          oldSlide.remove();
        }
        this.currentIndex = nextIndex;
        this.activeSlide = slide;
        this.activeClone = clone;
        this.activeCard = this.cards[nextIndex];
        if (clone) {
          clone.muted = false;
          clone.play().catch(() => {});
          clone.addEventListener('pause', () => this.updatePauseOverlay());
          clone.addEventListener('play', () => this.updatePauseOverlay());
        }
        this.updateViewerChrome(this.cards[nextIndex]);
        this.updateMuteIcon();
        this.preloadNeighbors();
      }, { once: true });

      previewSlide = null;
    };

    const cancelDrag = () => {
      if (this.activeSlide) {
        this.activeSlide.style.transition = 'transform .22s ease';
        this.activeSlide.style.transform = 'translateY(0)';
      }
      if (previewSlide) {
        const base = dragDirection > 0 ? '100%' : '-100%';
        previewSlide.style.transition = 'transform .22s ease';
        previewSlide.style.transform = 'translateY(' + base + ')';
        const p = previewSlide;
        p.addEventListener('transitionend', () => {
          const v = p.querySelector('video');
          if (v) v.pause();
          p.remove();
        }, { once: true });
      }
      previewSlide = null;
    };

    let pointerId = null;

    const endGesture = () => {
      if (pointerId !== null) {
        try { media.releasePointerCapture(pointerId); } catch (err) {}
      }
      pointerId = null;
      dragging = false;
      tapCandidate = false;
    };

    media.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      startTime = Date.now();
      tapCandidate = true;
      dragging = false;
      dragDirection = 0;
      pointerId = e.pointerId;
      try { media.setPointerCapture(e.pointerId); } catch (err) {}
    });

    media.addEventListener('pointermove', (e) => {
      if (pointerId === null || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
          tapCandidate = false;
          beginDrag(dy < 0 ? 1 : -1);
        } else if (Math.abs(dx) > 10) {
          tapCandidate = false;
          return;
        } else {
          return;
        }
      }
      if (dragging) {
        pendingDelta = dy;
        if (rafId === null) {
          rafId = requestAnimationFrame(() => {
            rafId = null;
            if (pendingDelta !== null) updateDrag(pendingDelta);
          });
        }
      }
    });

    media.addEventListener('pointerup', (e) => {
      if (pointerId === null || e.pointerId !== pointerId) return;
      const dy = e.clientY - startY;
      const elapsed = Date.now() - startTime;

      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      pendingDelta = null;

      if (dragging) {
        const passed = Math.abs(dy) > Math.min(mediaHeight() * 0.18, 90);
        if (passed) commitDrag(); else cancelDrag();
      } else if (tapCandidate && elapsed < 500) {
        this.togglePlayPause();
      }
      endGesture();
    });

    media.addEventListener('pointercancel', (e) => {
      if (pointerId === null || e.pointerId !== pointerId) return;
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      pendingDelta = null;
      if (dragging) cancelDrag();
      endGesture();
    });

    media.addEventListener('lostpointercapture', (e) => {
      if (pointerId === null || e.pointerId !== pointerId) return;
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      pendingDelta = null;
      if (dragging) cancelDrag();
      endGesture();
    });

    let wheelCooldown = false;
    this.addEventListener('wheel', (e) => {
      if (!this.classList.contains('is-open')) return;
      if (Math.abs(e.deltaY) < 12) return;
      if (wheelCooldown) return;
      wheelCooldown = true;
      this.go(e.deltaY > 0 ? 1 : -1);
      setTimeout(() => { wheelCooldown = false; }, 500);
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
      if (!this.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowUp') this.go(-1);
      if (e.key === 'ArrowDown') this.go(1);
    });
  }

  open(cards, startIndex) {
    this.cards = cards;
    this.currentIndex = startIndex;
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.showCurrent();
  }

  getCloneForCard(card, opts) {
    opts = opts || {};
    if (!this.preloadCache) this.preloadCache = new Map();
    let clone = this.preloadCache.get(card);
    if (clone) {
      this.preloadCache.delete(card);
    } else {
      const sourceVideo = card.querySelector('[data-kv-video]');
      if (!sourceVideo) return null;
      clone = sourceVideo.cloneNode(true);
      clone.removeAttribute('data-kv-video');
      clone.preload = 'auto';
    }
    clone.classList.add('kv-video-viewer__video-el');
    clone.style.position = '';
    clone.style.top = '';
    clone.style.left = '';
    clone.style.width = '';
    clone.style.height = '';
    clone.style.opacity = '';
    clone.style.pointerEvents = '';
    clone.muted = !!opts.silent;
    clone.currentTime = 0;
    return clone;
  }

  addLoadingScrim(slide, clone) {
    clone.classList.add('is-loading');
    const setLoading = () => clone.classList.add('is-loading');
    const setLoaded = () => clone.classList.remove('is-loading');
    clone.addEventListener('waiting', setLoading);
    clone.addEventListener('stalled', setLoading);
    clone.addEventListener('playing', setLoaded);
    clone.addEventListener('canplaythrough', setLoaded);
  }

  preloadNeighbors() {
    if (!this.cards || !this.cards.length) return;
    if (!this.preloadCache) this.preloadCache = new Map();
    [this.currentIndex - 1, this.currentIndex + 1].forEach((rawIdx) => {
      const idx = (rawIdx + this.cards.length) % this.cards.length;
      const card = this.cards[idx];
      if (!card || this.preloadCache.has(card)) return;
      const sourceVideo = card.querySelector('[data-kv-video]');
      if (!sourceVideo) return;
      const pre = sourceVideo.cloneNode(true);
      pre.removeAttribute('data-kv-video');
      pre.muted = true;
      pre.preload = 'auto';
      pre.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
      document.body.appendChild(pre);
      pre.load();
      this.preloadCache.set(card, pre);
    });
  }

  updateViewerChrome(card) {
    const headerEl = card.querySelector('.kv-video-card__header');
    this.querySelector('[data-kv-title]').textContent = headerEl ? headerEl.textContent : '';

    const tagEl = card.querySelector('.kv-video-card__tagbar');
    const tagSlot = this.querySelector('[data-kv-tag]');
    tagSlot.innerHTML = '';
    if (tagEl) {
      const tagClone = tagEl.cloneNode(true);
      tagSlot.appendChild(tagClone);
      const tagNextBtn = tagClone.querySelector('[data-kv-tag-next]');
      if (tagNextBtn) {
        tagNextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const rows = Array.from(tagClone.querySelectorAll('[data-kv-tag-row]'));
          const currentIndex = rows.findIndex((row) => !row.hidden);
          if (currentIndex === -1) return;
          rows[currentIndex].hidden = true;
          const nextIndex = (currentIndex + 1) % rows.length;
          rows[nextIndex].hidden = false;
        });
      }
    }

    const overlay = this.querySelector('[data-kv-pause-overlay]');
    if (overlay) overlay.style.display = 'none';
  }

  showCurrent(direction) {
    const card = this.cards[this.currentIndex];
    if (!card) return;

    const clone = this.getCloneForCard(card);
    if (!clone) return;

    const sourceVideo = card.querySelector('[data-kv-video]');
    const posterUrl = sourceVideo ? sourceVideo.getAttribute('poster') : '';
    if (posterUrl) clone.setAttribute('poster', posterUrl);
    const bg = document.createElement('div');
    bg.className = 'kv-video-viewer__media-bg';
    if (posterUrl) bg.style.backgroundImage = 'url(' + posterUrl + ')';

    const slide = document.createElement('div');
    slide.className = 'kv-video-viewer__slide';
    slide.appendChild(bg);
    slide.appendChild(clone);
    this.addLoadingScrim(slide, clone);

    const media = this.querySelector('[data-kv-media]');
    const oldSlide = this.activeSlide;

    if (direction && oldSlide) {
      slide.style.transform = direction > 0 ? 'translateY(100%)' : 'translateY(-100%)';
      media.appendChild(slide);
      slide.getBoundingClientRect();
      requestAnimationFrame(() => {
        slide.style.transition = 'transform .32s cubic-bezier(.22,.61,.36,1)';
        oldSlide.style.transition = 'transform .32s cubic-bezier(.22,.61,.36,1)';
        slide.style.transform = 'translateY(0)';
        oldSlide.style.transform = direction > 0 ? 'translateY(-100%)' : 'translateY(100%)';
      });
      const oldVideo = oldSlide.querySelector('video');
      if (oldVideo) oldVideo.pause();
      slide.addEventListener('transitionend', () => {
        oldSlide.remove();
      }, { once: true });
    } else {
      if (oldSlide) oldSlide.remove();
      media.appendChild(slide);
    }

    clone.play().catch(() => {});

    clone.addEventListener('pause', () => this.updatePauseOverlay());
    clone.addEventListener('play', () => this.updatePauseOverlay());

    this.activeClone = clone;
    this.activeCard = card;
    this.activeSlide = slide;

    this.updateViewerChrome(card);
    this.updateMuteIcon();
    this.preloadNeighbors();
  }

  go(direction) {
    if (!this.cards || !this.cards.length) return;
    const nextIndex = (this.currentIndex + direction + this.cards.length) % this.cards.length;
    this.currentIndex = nextIndex;
    this.showCurrent(direction);
  }

  toggleMute() {
    if (!this.activeClone) return;
    this.activeClone.muted = !this.activeClone.muted;
    this.updateMuteIcon();
  }

  updateMuteIcon() {
    const isMuted = this.activeClone ? this.activeClone.muted : true;
    this.classList.toggle('is-muted', isMuted);
    this.querySelectorAll('.kv-video-viewer__icon-unmuted').forEach((el) => { el.style.display = isMuted ? 'none' : ''; });
    this.querySelectorAll('.kv-video-viewer__icon-muted').forEach((el) => { el.style.display = isMuted ? '' : 'none'; });
  }

  togglePlayPause() {
    if (!this.activeClone) return;
    if (this.activeClone.paused) this.activeClone.play();
    else this.activeClone.pause();
    this.updatePauseOverlay();
  }

  updatePauseOverlay() {
    const overlay = this.querySelector('[data-kv-pause-overlay]');
    if (!overlay || !this.activeClone) return;
    overlay.style.display = this.activeClone.paused ? 'flex' : 'none';
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.activeClone) {
      window.kvOpenMiniPlayer(this.activeClone, this.cards, this.currentIndex);
    }
    if (this.preloadCache) {
      this.preloadCache.forEach((v) => { v.pause(); v.remove(); });
      this.preloadCache.clear();
    }
    this.activeClone = null;
    this.activeCard = null;
    this.activeSlide = null;
  }
}
customElements.define('kv-video-viewer', KvVideoViewer);

class KvMiniPlayer extends HTMLElement {
  connectedCallback() {
      this.style.cssText = 'display:none;position:fixed;bottom:24px;right:20px;z-index:500000;width:280px;border-radius:16px;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(white, black);box-shadow:0 8px 40px rgba(0,0,0,.25);background:#fff;';
    this.innerHTML = `
      <div data-kv-mini-media style="width:100%;aspect-ratio:9/16;position:relative;background:#f5efe6;">
        <button type="button" data-kv-mini-close aria-label="Close" style="position:absolute;top:8px;right:8px;z-index:10;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.45);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">
          <svg width="7" height="7" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1l-8 8" stroke="white" stroke-width="1.8" stroke-linecap="round"></path></svg>
        </button>
        <button type="button" data-kv-mini-prev aria-label="Previous video" style="position:absolute;left:6px;top:50%;transform:translateY(-50%);z-index:10;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.35);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">
          <svg width="6" height="10" viewBox="0 0 10 16" fill="none"><path d="M8 2L2 8L8 14" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button type="button" data-kv-mini-next aria-label="Next video" style="position:absolute;right:6px;top:50%;transform:translateY(-50%);z-index:10;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.35);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">
          <svg width="6" height="10" viewBox="0 0 10 16" fill="none"><path d="M2 2L8 8L2 14" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <div style="position:absolute;bottom:0;left:0;right:0;z-index:10;background:linear-gradient(to top,rgba(26,26,23,.6),transparent);padding:20px 10px 10px;display:flex;align-items:flex-end;justify-content:space-between;gap:6px;">
          <button type="button" data-kv-mini-toggle aria-label="Pause" style="width:22px;height:22px;border-radius:50%;background:rgba(255,255,255,.25);border:none;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;padding:0;">
            <svg class="kv-mini-player__icon-play" width="8" height="10" viewBox="0 0 8 10" fill="white"><polygon points="0,0 8,5 0,10"></polygon></svg>
            <svg class="kv-mini-player__icon-pause" width="8" height="10" viewBox="0 0 8 10" fill="white" style="display:none;"><rect x="0" y="0" width="3" height="10"></rect><rect x="5" y="0" width="3" height="10"></rect></svg>
          </button>
          <div data-kv-mini-dots style="display:flex;gap:3px;align-items:center;justify-content:center;flex:1;"></div>
          <button type="button" data-kv-mini-mute aria-label="Mute" style="width:22px;height:22px;border-radius:50%;background:rgba(255,255,255,.25);border:none;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;padding:0;">
            <svg class="kv-mini-player__icon-unmuted" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
            <svg class="kv-mini-player__icon-muted" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" style="display:none;"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
          </button>
        </div>
      </div>
    `;
    this.querySelector('[data-kv-mini-close]').addEventListener('click', () => this.closePlayer());
    this.querySelector('[data-kv-mini-toggle]').addEventListener('click', () => this.togglePlay());
    this.querySelector('[data-kv-mini-mute]').addEventListener('click', () => this.toggleMute());
    this.querySelector('[data-kv-mini-prev]').addEventListener('click', () => this.go(-1));
    this.querySelector('[data-kv-mini-next]').addEventListener('click', () => this.go(1));

    const media = this.querySelector('[data-kv-mini-media]');
    media.addEventListener('click', (e) => {
      if (e.target.closest('button')) return;
      this.togglePlay();
    });
  }

  show(video, cards, index) {
    const media = this.querySelector('[data-kv-mini-media]');
    video.classList.remove('kv-video-viewer__video-el');
    video.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;z-index:1;';
    media.appendChild(video);
    this.style.display = 'block';
    this.currentVideo = video;
    this.cards = cards || [];
    this.currentIndex = typeof index === 'number' ? index : -1;
    video.play().catch(() => {});
    video.addEventListener('play', () => this.updatePlayIcon());
    video.addEventListener('pause', () => this.updatePlayIcon());
    this.updatePlayIcon();
    this.updateMuteIcon();
    this.updateNavState();
  }

  go(direction) {
    if (!this.cards || this.cards.length < 2) return;
    const nextIndex = (this.currentIndex + direction + this.cards.length) % this.cards.length;
    this.goTo(nextIndex);
  }

  goTo(index) {
    if (!this.cards || !this.cards[index]) return;
    this.currentIndex = index;
    const card = this.cards[this.currentIndex];
    const sourceVideo = card.querySelector('[data-kv-video]');
    if (!sourceVideo) return;

    if (this.currentVideo) {
      this.currentVideo.pause();
      this.currentVideo.remove();
    }

    const clone = sourceVideo.cloneNode(true);
    clone.removeAttribute('data-kv-video');
    clone.muted = false;
    clone.currentTime = 0;
    clone.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;z-index:1;';

    const media = this.querySelector('[data-kv-mini-media]');
    media.appendChild(clone);
    clone.play().catch(() => {});
    clone.addEventListener('play', () => this.updatePlayIcon());
    clone.addEventListener('pause', () => this.updatePlayIcon());

    this.currentVideo = clone;
    this.updatePlayIcon();
    this.updateMuteIcon();
    this.updateNavState();
  }

  updateNavState() {
    const prevBtn = this.querySelector('[data-kv-mini-prev]');
    const nextBtn = this.querySelector('[data-kv-mini-next]');
    const dotsWrap = this.querySelector('[data-kv-mini-dots]');
    const hasCards = this.cards && this.cards.length > 1;
    if (prevBtn) prevBtn.style.display = hasCards ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = hasCards ? 'flex' : 'none';
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      if (hasCards) {
        this.cards.forEach((_, i) => {
          const dot = document.createElement('button');
          const active = i === this.currentIndex;
          dot.type = 'button';
          dot.style.cssText = 'width:' + (active ? '14px' : '5px') + ';height:5px;border-radius:999px;border:none;cursor:pointer;transition:all .2s;background:' + (active ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,.4)') + ';padding:0;';
          dot.addEventListener('click', () => this.goTo(i));
          dotsWrap.appendChild(dot);
        });
      }
    }
  }

  togglePlay() {
    if (!this.currentVideo) return;
    if (this.currentVideo.paused) this.currentVideo.play();
    else this.currentVideo.pause();
  }

  toggleMute() {
    if (!this.currentVideo) return;
    this.currentVideo.muted = !this.currentVideo.muted;
    this.updateMuteIcon();
  }

  updatePlayIcon() {
    const playIcon = this.querySelector('.kv-mini-player__icon-play');
    const pauseIcon = this.querySelector('.kv-mini-player__icon-pause');
    if (!playIcon || !pauseIcon || !this.currentVideo) return;
    playIcon.style.display = this.currentVideo.paused ? '' : 'none';
    pauseIcon.style.display = this.currentVideo.paused ? 'none' : '';
  }

  updateMuteIcon() {
    const unmutedIcon = this.querySelector('.kv-mini-player__icon-unmuted');
    const mutedIcon = this.querySelector('.kv-mini-player__icon-muted');
    if (!unmutedIcon || !mutedIcon || !this.currentVideo) return;
    unmutedIcon.style.display = this.currentVideo.muted ? 'none' : '';
    mutedIcon.style.display = this.currentVideo.muted ? '' : 'none';
  }

  closePlayer() {
    if (this.currentVideo) {
      this.currentVideo.pause();
      this.currentVideo.remove();
    }
    this.style.display = 'none';
    this.currentVideo = null;
    this.cards = null;
    this.currentIndex = -1;
  }
}
customElements.define('kv-mini-player', KvMiniPlayer);

window.kvOpenMiniPlayer = function (video, cards, index) {
  let mini = document.querySelector('kv-mini-player');
  if (!mini) {
    mini = document.createElement('kv-mini-player');
    document.body.appendChild(mini);
  }
  mini.classList.toggle('kv-mini-player--home', window.location.pathname === '/');
  mini.show(video, cards, index);
};

let kvSoundOn = false;

function kvInitVideoGrids() {
  const cards = document.querySelectorAll('.kv-video-card:not([data-kv-init])');
  if (!cards.length) return;

  cards.forEach((card) => {
    card.setAttribute('data-kv-init', 'true');
    const video = card.querySelector('[data-kv-video]');
    const muteBtn = card.querySelector('[data-kv-video-mute]');
    const expandBtn = card.querySelector('[data-kv-video-open]');

    card.classList.toggle('is-muted', video.muted);

    const posterUrl = video.getAttribute('poster');
    if (posterUrl) {
      const posterEl = document.createElement('div');
      posterEl.className = 'kv-video-card__poster';
      posterEl.style.backgroundImage = 'url(' + posterUrl + ')';
      video.insertAdjacentElement('afterend', posterEl);
      const showPoster = () => posterEl.classList.remove('is-hidden');
      const hidePoster = () => posterEl.classList.add('is-hidden');
      if (video.readyState >= 3) hidePoster();
      video.addEventListener('waiting', showPoster);
      video.addEventListener('stalled', showPoster);
      video.addEventListener('playing', hidePoster);
      video.addEventListener('canplaythrough', hidePoster);
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        card.classList.toggle('is-muted', video.muted);
        kvSoundOn = !video.muted;
      });
    }

    const tagNextBtn = card.querySelector('[data-kv-tag-next]');
    if (tagNextBtn) {
      tagNextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const rows = Array.from(card.querySelectorAll('[data-kv-tag-row]'));
        const currentIndex = rows.findIndex((row) => !row.hidden);
        if (currentIndex === -1) return;
        rows[currentIndex].hidden = true;
        const nextIndex = (currentIndex + 1) % rows.length;
        rows[nextIndex].hidden = false;
      });
    }

    const openViewer = (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }

      document.querySelectorAll('[data-kv-video]').forEach((v) => {
        v.muted = true;
        const c = v.closest('.kv-video-card');
        if (c) c.classList.add('is-muted');
      });
      kvSoundOn = false;
      const mini = document.querySelector('kv-mini-player');
      if (mini && mini.currentVideo) {
        mini.currentVideo.muted = true;
        mini.updateMuteIcon();
      }

      const grid = card.closest('[data-kv-video-grid]');
      const cardsInGrid = Array.from(grid.querySelectorAll('.kv-video-card'));
      const index = cardsInGrid.indexOf(card);
      let viewer = document.querySelector('kv-video-viewer');
      if (!viewer) {
        viewer = document.createElement('kv-video-viewer');
        document.body.appendChild(viewer);
      }
      viewer.open(cardsInGrid, index);
    };

    if (expandBtn) expandBtn.addEventListener('click', openViewer);

    card.addEventListener('click', (e) => {
      if (e.target.closest('[data-kv-video-mute]') || e.target.closest('[data-kv-tagbar]') || e.target.closest('[data-kv-video-open]')) return;
      video.muted = !video.muted;
      card.classList.toggle('is-muted', video.muted);
      kvSoundOn = !video.muted;
    });
  });

  document.querySelectorAll('.kv-video-scroller:not([data-kv-scroller-init])').forEach((scroller) => {
    scroller.setAttribute('data-kv-scroller-init', 'true');
    const grid = scroller.querySelector('[data-kv-video-grid]');
    const prevBtn = scroller.querySelector('[data-kv-scroll-prev]');
    const nextBtn = scroller.querySelector('[data-kv-scroll-next]');
    if (!grid) return;

    const scrollByCard = (direction) => {
      const card = grid.querySelector('.kv-video-card');
      if (!card) return;
      const amount = card.getBoundingClientRect().width + 12;
      grid.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    const updateArrowState = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (!isDesktop) {
        if (prevBtn) prevBtn.style.display = '';
        if (nextBtn) nextBtn.style.display = '';
        return;
      }
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      const scrollLeft = grid.scrollLeft;
      if (prevBtn) prevBtn.style.display = scrollLeft > 4 ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = maxScroll > 4 && scrollLeft < maxScroll - 4 ? 'flex' : 'none';
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));

    grid.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });

  if ('IntersectionObserver' in window) {
    const warmObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const v = entry.target.querySelector('[data-kv-video]');
        if (!v || v.dataset.kvWarmed) return;
        v.dataset.kvWarmed = 'true';
        v.preload = 'auto';
        v.load();
      });
    }, { threshold: 0, rootMargin: '0px 600px 0px 600px' });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target.querySelector('[data-kv-video]');
        if (!v) return;
        if (entry.isIntersecting) {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          if (isMobile && kvSoundOn) {
            v.muted = false;
            entry.target.classList.remove('is-muted');
          }
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.6 });

    cards.forEach((card) => {
      warmObserver.observe(card);
      observer.observe(card);
    });
  }
}

document.addEventListener('DOMContentLoaded', kvInitVideoGrids);
document.addEventListener('shopify:section:load', kvInitVideoGrids);